/**
 * Calcul la remise sur les frais de réservation
 */
export default function bookingEstimateGetDiscountServiceFeeAmount({
  serviceFeeAmount,
  baseServiceFeeAmount,
}) {
  return serviceFeeAmount - baseServiceFeeAmount;
}
